import { garbage } from '@/api/api-endpoints'

export default {
  computed: {
    filterEndpoint() {
      return garbage.garbages
    },
  },
  methods: {
    updateItems(response) {
      this.$store.commit('mutateEndpoint', {
        endpoint: this.getEndpoint(this.$route),
        response,
      })
    },
  },
}
